export const VAULTURE_USERNAME_KEY = 'vaulture_user_name'
export const VAULTURE_USERID_KEY = 'valuture_user_id'
export const VAULTURE_USER_AVATAR_KEY = 'vaulture_user_avatar'

export const VAULTURE_VIEW_LAYOUT_MODE = 'vaulture_view_layout_mode'
export const VAULTURE_LANGUAGE_PREF = 'vaulture_language_pref'
